import ValuePlaceholder from '../ValuePlaceholder';

interface Props {
  value: any;
  placeholder?: string;
}

export default function Value({ value, placeholder }: Props) {
  if (placeholder && (value === undefined || value === null)) {
    return <ValuePlaceholder placeholder={placeholder} />;
  }

  return <>{value}</>;
}
